import { Directive, ElementRef, HostListener, Renderer2, input } from '@angular/core';
import { ScreenService } from 'lib/screen/index.js';

@Directive({
    selector: '[libHover]',
    standalone: false
})
export class HoverDirective {
	public readonly libHover = input.required<string>();
	private readonly enableHover: boolean;

	@HostListener('mouseover') onMouseOver(): void {
		if (!this.enableHover) {
			return;
		}

		if (this.hostElement?.nativeElement) {
			this.renderer2.addClass(this.hostElement.nativeElement, this.libHover());
		}
	}

	@HostListener('mouseout') onMouseOut(): void {
		if (!this.enableHover) {
			return;
		}

		if (this.hostElement?.nativeElement) {
			this.renderer2.removeClass(this.hostElement.nativeElement, this.libHover());
		}
	}

	constructor(
		private readonly hostElement: ElementRef,
		private readonly renderer2: Renderer2,
		readonly screenService: ScreenService
	) {
		const platform = screenService.currentScreen().platform;

		if (platform === 'mobile' || platform === 'tablet') {
			this.enableHover = false;
		} else {
			this.enableHover = true;
		}
	}
}
